// extracted by mini-css-extract-plugin
export default {"thankyou":"style_thankyou__YWNbB","content":"style_content__Yl4rt","icon":"style_icon__LktbT","row":"style_row__QYDYF","grid":"style_grid__qPjEr","btnRow":"style_btnRow__KSYdY"};